export default "__VITE_ASSET__BJfI3JiZ__"